export default "__VITE_ASSET__VwFyoEVe__"